export default __webpack_public_path__ + "ui/assets/img/arrow-right-disabled-24.svg";